import Swiper from 'swiper';
import {
    A11y,
    Navigation
} from 'swiper/modules';
import 'swiper/css';

/**
 * Master layout: Related Links.
 * Slide widths are fixed in CSS (187px mobile / 400px desktop), so `slidesPerView: 'auto'`
 * reads them directly. On desktop the three cards fill the 1240px container exactly, so
 * `watchOverflow` disables dragging there; on mobile they overflow into a one-at-a-time carousel.
 */
export function initRelatedLinks() {
    document.querySelectorAll('[data-related-links]').forEach((sectionEl) => {
        const el = sectionEl.querySelector('.related-links__swiper');
        if (!el) {
            return;
        }

        const slideCount = el.querySelectorAll('.swiper-slide').length;
        if (slideCount < 1) {
            return;
        }

        const prevEl = sectionEl.querySelector('.related-links__nav-prev');
        const nextEl = sectionEl.querySelector('.related-links__nav-next');

        new Swiper(el, {
            modules: [Navigation, A11y],
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 12,
            speed: 400,
            grabCursor: true,
            loop: false,
            watchOverflow: true,
            roundLengths: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                1024: {
                    spaceBetween: 20,
                },
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous card',
                nextSlideMessage: 'Next card',
            },
            navigation: {
                prevEl: prevEl || undefined,
                nextEl: nextEl || undefined,
            },
        });
    });
}
